<template>
  <v-data-table
    v-bind="$props"
    :headers="extendedHeaders"
    :items-per-page="itemsPerPage"
    :item-class="extendedItemClass"
    dense
    :disable-sort="disableSort"
    :class="interactable ? 'cassie-table' : 'cassie-table--no-hover'"
    no-data-text="No data available"
    fixed-header
    :height="defaultHeight"
    @current-items="$emit('current-items', $event)"
    v-on="$listeners"
  >
    <template #item.selected-column="{ item: row }">
      <v-icon :color="rowSelected(row) ? 'info' : ''">
        {{ rowSelected(row) ?
          multiSelect ? '$checkboxOn' : 'mdi-radiobox-marked' :
          multiSelect ? '$checkboxOff': 'mdi-radiobox-blank'
        }}
      </v-icon>
    </template>
    <template
      v-for="slot in slots"
      #[slot]="props"
    >
      <slot
        :name="slot"
        v-bind="props"
      />
    </template>
  </v-data-table>
</template>

<script lang="ts">
import Vue from 'vue'
import { VDataTable } from 'vuetify/lib'
import type { DataTableProps } from './types'

export default Vue.extend({
  name: 'DataTable',
  extends: VDataTable,
  props: {
    selected: {
      type: Function,
      default: undefined
    },
    multiSelect: {
      type: Boolean,
      default: false
    },
    disableSort: {
      type: Boolean,
      default: false
    },
    itemsPerPage: {
      type: Number,
      default: 15
    },
    height: {
      type: String,
      default: undefined
    },
    interactable: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  computed: {
    hasRowSelected(): boolean {
      return !!this.selected
    },
    slots(): string[] {
      return Object.keys(this.$scopedSlots)
    },
    extendedHeaders(): any[] {
      if (!this.hasRowSelected) return this.headers
      return [
        { width: 35, value: 'selected-column', align: 'center' },
        ...this.headers
      ]
    },
    defaultHeight(): string {
      if (this.height) return this.height
      if (this.$props.items.length >= 15) return '525'
      return 'auto'
    }
  },
  methods: {
    rowSelected(row: any): boolean {
      return this.hasRowSelected && this.selected ? this.selected(row) : false
    },
    extendedItemClass(row: any): string {
      const extendedClass = this.rowSelected(row) ? 'blue lighten-5' : ''
      return this.itemClass ? `${this.itemClass(row)} ${extendedClass}` : extendedClass
    }
  }
})
</script>

<style lang="scss">
@import './styles.scss';
</style>
